import { useState } from 'react';
import Modal from './Modal.js';
import { useCreateWorkspace } from '../api/hooks.js';
import { setWorkspaceId } from '../workspace.js';
import { ApiError } from '../api/client.js';

export default function CreateWorkspaceModal({
  open,
  onClose,
}: { open: boolean; onClose: () => void }) {
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const create = useCreateWorkspace();

  return (
    <Modal
      open={open}
      onClose={() => {
        if (!create.isPending) {
          setName('');
          setError(null);
          onClose();
        }
      }}
      title="Create workspace"
    >
      <form
        className="space-y-3"
        onSubmit={async (e) => {
          e.preventDefault();
          setError(null);
          try {
            const res = await create.mutateAsync({ name: name.trim() });
            // Switch the active workspace so the user lands in the new one immediately.
            setWorkspaceId(res.workspace.id);
            setName('');
            onClose();
          } catch (err) {
            if (err instanceof ApiError) {
              const code = (err.payload as { error?: string })?.error ?? 'request_failed';
              setError(code.replace(/_/g, ' '));
            } else {
              setError('Something went wrong.');
            }
          }
        }}
      >
        <div>
          <label className="label" htmlFor="ws-name">Workspace name</label>
          <input
            id="ws-name"
            type="text"
            required
            autoFocus
            maxLength={80}
            placeholder="e.g. Acme Marketing"
            className="input mt-1"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <p className="mt-1 text-xs text-slate-500">
            You'll be the owner. Add teammates from the Workspace tab.
          </p>
        </div>
        {error && (
          <p className="rounded-md bg-red-50 p-2 text-sm text-red-700">{error}</p>
        )}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" className="btn-secondary" onClick={onClose} disabled={create.isPending}>
            Cancel
          </button>
          <button type="submit" className="btn-primary" disabled={create.isPending || !name.trim()}>
            {create.isPending ? 'Creating…' : 'Create workspace'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
